import { Injectable } from '@angular/core';

export type ComparisonAnalyticsEventName =
  | 'fundraising_comparison_loaded'
  | 'fundraising_scenario_changed'
  | 'fundraising_platform_option_changed'
  | 'fundraising_platform_configuration_opened'
  | 'fundraising_platform_calculator_loaded'
  | 'fundraising_platform_detail_link_clicked'
  | 'fundraising_platform_overview_link_clicked'
  | 'fundraising_platform_link_copied'
  | 'fundraising_versus_loaded'
  | 'fundraising_versus_amount_changed'
  | 'fundraising_versus_left_option_changed'
  | 'fundraising_versus_right_option_changed'
  | 'fundraising_versus_details_opened'
  | 'fundraising_versus_platform_link_clicked'
  | 'fundraising_versus_overview_link_clicked'
  | 'fundraising_versus_link_copied'
  | 'calculation_details_opened'
  | 'fundraising_comparison_link_copied'
  | 'fundraising_overview_versus_link_clicked'
  | 'fundraising_pricing_source_opened'
  | 'platform_quick_view_opened'
  | 'platform_quick_configuration_changed'
  | 'platform_quick_view_closed'
  | 'platform_full_page_clicked'
  | 'comparison_reset';

@Injectable({ providedIn: 'root' })
export class ComparisonAnalyticsService {
  track(
    eventName: ComparisonAnalyticsEventName,
    detail: Record<string, string | number | boolean> = {},
  ): void {
    if (typeof window === 'undefined') {
      return;
    }
    window.dispatchEvent(
      new CustomEvent('big-nest:fundraising-comparison', {
        detail: { eventName, ...detail },
      }),
    );
  }

  amountBucket(amountCents: number): string {
    const dollars = amountCents / 100;
    if (dollars < 5_000) return 'under-5k';
    if (dollars < 20_000) return '5k-20k';
    if (dollars < 50_000) return '20k-50k';
    return '50k-plus';
  }

  donationCountBucket(donationCount: number): string {
    if (donationCount < 100) return 'under-100';
    if (donationCount < 500) return '100-499';
    if (donationCount < 1_000) return '500-999';
    return '1000-plus';
  }
}
